import { render, staticRenderFns } from "./SearchTransactions.vue?vue&type=template&id=884ed3e6&scoped=true"
import script from "./SearchTransactions.vue?vue&type=script&lang=ts"
export * from "./SearchTransactions.vue?vue&type=script&lang=ts"
import style0 from "./SearchTransactions.vue?vue&type=style&index=0&id=884ed3e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ed3e6",
  null
  
)

export default component.exports